/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FavoritesContainer_viewer$ref = any;
export type PortfolioItemsSortByTypes = "CUSTOM" | "NET_PRICE_ASC" | "NET_PRICE_DESC" | "PRICE_ASC" | "PRICE_DESC" | "RECENTLY_CREATED" | "RECENTLY_MODIFIED" | "%future added value";
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosSortByTypes = "ALPHABETICAL" | "CREATED" | "CUSTOM" | "MODIFIED" | "%future added value";
export type favoritesRootQueryVariables = {
    readonly page: number;
    readonly userId: string;
    readonly after?: string | null;
    readonly userIds: ReadonlyArray<string | null>;
    readonly hasUserId: boolean;
    readonly first: number;
    readonly sortBy?: PortfolioItemsSortByTypes | null;
    readonly foldersSort?: PortfoliosSortByTypes | null;
    readonly searchTerm?: string | null;
    readonly portfolioIds?: ReadonlyArray<string | null> | null;
    readonly portfolioTypes?: ReadonlyArray<PortfolioTypes | null> | null;
    readonly projectId: string;
    readonly loadPortfolioData: boolean;
    readonly selectedItemIds: ReadonlyArray<string | null>;
    readonly useProjectEndpoint: boolean;
    readonly isDiscover: boolean;
    readonly isFolders: boolean;
    readonly isFollowing: boolean;
    readonly isItems: boolean;
    readonly isProjects: boolean;
    readonly isSinglePortfolio: boolean;
    readonly isTrade: boolean;
    readonly itemId?: string | null;
    readonly shouldFetchItem?: boolean | null;
    readonly itemIds?: ReadonlyArray<string | null> | null;
    readonly shouldFetchConversation?: boolean | null;
    readonly shouldFetchTransaction?: boolean | null;
    readonly showSeller: boolean;
    readonly zipCode?: string | null;
    readonly country?: string | null;
    readonly canCheckZipCode?: boolean | null;
    readonly conversationId?: string | null;
    readonly hasConversationId?: boolean | null;
};
export type favoritesRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FavoritesContainer_viewer$ref;
    } | null;
};
export type favoritesRootQuery = {
    readonly response: favoritesRootQueryResponse;
    readonly variables: favoritesRootQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "after",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "sortBy",
            "type": "PortfolioItemsSortByTypes",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "foldersSort",
            "type": "PortfoliosSortByTypes",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "searchTerm",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "portfolioIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "portfolioTypes",
            "type": "[PortfolioTypes]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "projectId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "useProjectEndpoint",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isDiscover",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isFolders",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isFollowing",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isItems",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isProjects",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isSinglePortfolio",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchItem",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "itemIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchConversation",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchTransaction",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "showSeller",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "zipCode",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "country",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "canCheckZipCode",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "conversationId",
            "type": "ID",
            "defaultValue": 0
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasConversationId",
            "type": "Boolean",
            "defaultValue": false
        } as any)
    ], v1 = ({
        "kind": "Literal",
        "name": "numItems",
        "value": 2
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
    } as any), v4 = [
        (v2 /*: any*/),
        (v3 /*: any*/)
    ], v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerifiedTrade",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any), v9 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "portfolioItemId",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v12 = [
        (v11 /*: any*/),
        (v5 /*: any*/)
    ], v13 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": "onlyTradeRequestsQuote",
        "name": "isEnabled",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "useOldPdpShippingModals"
            }
        ],
        "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
    } as any), v19 = [
        (v16 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "abbreviation",
            "args": null,
            "storageKey": null
        } as any)
    ], v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "geography",
        "storageKey": null,
        "args": null,
        "concreteType": "Geography",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "countries",
                "storageKey": null,
                "args": null,
                "concreteType": "GeographyObject",
                "plural": true,
                "selections": (v19 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "usStates",
                "storageKey": null,
                "args": null,
                "concreteType": "GeographyObject",
                "plural": true,
                "selections": (v19 /*: any*/)
            }
        ]
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": "isVisuallySimilarEnabled",
        "name": "isEnabledByLocale",
        "args": [
            {
                "kind": "Literal",
                "name": "featureName",
                "value": "VISUALLY_SIMILAR"
            }
        ],
        "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "firstValidShippingAddress",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v12 /*: any*/)
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "formattedAddress",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "line1",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "country",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zipCode",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "addressBook",
        "storageKey": null,
        "args": null,
        "concreteType": "AddressBook",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "addressList",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sourceId",
                        "args": null,
                        "storageKey": null
                    },
                    (v11 /*: any*/),
                    (v2 /*: any*/),
                    (v27 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayCountry",
                        "args": null,
                        "storageKey": null
                    },
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v28 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "line2",
                        "args": null,
                        "storageKey": null
                    },
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "phoneNumber",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "validation",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AddressValidation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "buyerShipping",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ValidationResult",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "valid",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    (v5 /*: any*/)
                ]
            }
        ]
    } as any), v34 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "tradeFirm",
        "storageKey": null,
        "args": null,
        "concreteType": "TradeFirmType",
        "plural": false,
        "selections": (v12 /*: any*/)
    } as any), v35 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userId"
    } as any), v36 = ({
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
    } as any), v37 = [
        (v35 /*: any*/),
        (v36 /*: any*/)
    ], v38 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v39 = [
        (v38 /*: any*/)
    ], v40 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustom",
        "args": null,
        "storageKey": null
    } as any), v41 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 200
        } as any),
        (v9 /*: any*/)
    ], v42 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v6 /*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "profile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Profile",
                        "plural": false,
                        "selections": [
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/)
                        ]
                    },
                    (v11 /*: any*/),
                    (v26 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantShippingInfo",
                "storageKey": null,
                "args": (v37 /*: any*/),
                "concreteType": "QueryRelevantShippingInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipmentQuote",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "subTotalAmount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v39 /*: any*/)
                            },
                            (v40 /*: any*/),
                            (v5 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "projects",
                "storageKey": null,
                "args": (v41 /*: any*/),
                "concreteType": "ProjectConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Project",
                                "plural": false,
                                "selections": [
                                    (v11 /*: any*/),
                                    (v16 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "portfolio",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioV2",
                                        "plural": false,
                                        "selections": (v12 /*: any*/)
                                    },
                                    (v5 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v43 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isSold",
        "args": null,
        "storageKey": null
    } as any), v44 = [
        (v35 /*: any*/)
    ], v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is1stdibsBilledQuote",
        "args": null,
        "storageKey": null
    } as any), v46 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is1stdibsWhiteGloveQuote",
        "args": null,
        "storageKey": null
    } as any), v47 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "handlingTimeDisplay",
        "args": null,
        "storageKey": null
    } as any), v48 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v24 /*: any*/),
            (v38 /*: any*/)
        ]
    } as any), v49 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "totalAmount",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": [
            (v24 /*: any*/),
            (v38 /*: any*/),
            (v48 /*: any*/)
        ]
    } as any), v50 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "buyerServiceMethodDisplay",
        "args": null,
        "storageKey": null
    } as any), v51 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "handlingTime",
        "storageKey": null,
        "args": null,
        "concreteType": "Period",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "numberOfUnits",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v52 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "regionName",
        "args": null,
        "storageKey": null
    } as any), v53 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "serviceMethod",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentServiceMethod",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceType",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceMethodType",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "region",
                "storageKey": null,
                "args": null,
                "concreteType": "Region",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                    },
                    (v52 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "regionType",
                        "args": null,
                        "storageKey": null
                    },
                    (v5 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "regionBoundary",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RegionBoundary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "type",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RegionBoundaryType",
                                "plural": false,
                                "selections": [
                                    (v16 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "windowMin",
                "storageKey": null,
                "args": null,
                "concreteType": "Period",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": "numberOfDays",
                        "name": "numberOfUnits",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            (v5 /*: any*/)
        ]
    } as any), v54 = [
        (v48 /*: any*/)
    ], v55 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v56 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "shouldFetchItem",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": [
                    (v36 /*: any*/),
                    {
                        "kind": "Literal",
                        "name": "pageType",
                        "value": "SHIPPING_MODAL"
                    }
                ],
                "concreteType": "Item",
                "plural": false,
                "selections": [
                    (v17 /*: any*/),
                    (v43 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "seller",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Seller",
                        "plural": false,
                        "selections": [
                            (v11 /*: any*/),
                            (v5 /*: any*/),
                            {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "hasUserId",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "favoritesByUser",
                                        "storageKey": null,
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "userIds",
                                                "variableName": "userId"
                                            }
                                        ],
                                        "concreteType": "Favorite",
                                        "plural": true,
                                        "selections": (v12 /*: any*/)
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasPreQuotedShipping",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": "itemIsOnHold",
                        "name": "isOnHold",
                        "args": (v44 /*: any*/),
                        "storageKey": null
                    },
                    (v5 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "address",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Address",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": "itemAddress",
                                "name": "displayCityStateCountry",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "fullCountryName",
                                        "value": true
                                    }
                                ],
                                "storageKey": "displayCityStateCountry(fullCountryName:true)"
                            },
                            (v5 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantShippingInfo",
                "storageKey": null,
                "args": (v37 /*: any*/),
                "concreteType": "QueryRelevantShippingInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipment",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Shipment",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "shippingAddress",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Address",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "displayCityStateCountry",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v5 /*: any*/)
                                ]
                            },
                            (v5 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipmentQuote",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "plural": false,
                        "selections": [
                            (v40 /*: any*/),
                            (v11 /*: any*/),
                            (v45 /*: any*/),
                            (v46 /*: any*/),
                            (v47 /*: any*/),
                            (v49 /*: any*/),
                            (v50 /*: any*/),
                            (v51 /*: any*/),
                            (v53 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "buyerSubTotalAmount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v54 /*: any*/)
                            },
                            (v5 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuotes",
                "storageKey": null,
                "args": [
                    (v55 /*: any*/),
                    (v36 /*: any*/),
                    {
                        "kind": "Literal",
                        "name": "searchView",
                        "value": "IGNORE_LOCAL_PICKUP"
                    }
                ],
                "concreteType": "ShipmentQuotesConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentQuotesEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ShipmentQuote",
                                "plural": false,
                                "selections": [
                                    (v11 /*: any*/),
                                    (v45 /*: any*/),
                                    (v46 /*: any*/),
                                    (v47 /*: any*/),
                                    (v49 /*: any*/),
                                    (v50 /*: any*/),
                                    (v51 /*: any*/),
                                    (v53 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "buyerSubTotalAmount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "plural": false,
                                        "selections": [
                                            (v38 /*: any*/),
                                            (v48 /*: any*/)
                                        ]
                                    },
                                    (v5 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v57 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "shouldFetchConversation",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerItemConversation",
                "storageKey": null,
                "args": (v37 /*: any*/),
                "concreteType": "Conversation",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v11 /*: any*/)
                ]
            }
        ]
    } as any), v58 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCanceled",
        "args": null,
        "storageKey": null
    } as any), v59 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasCompletedCheckout",
        "args": null,
        "storageKey": null
    } as any), v60 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v61 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "shouldFetchTransaction",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "transactions",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "buyerId",
                        "variableName": "userIds"
                    },
                    (v13 /*: any*/),
                    {
                        "kind": "Variable",
                        "name": "itemId",
                        "variableName": "itemIds"
                    },
                    {
                        "kind": "Literal",
                        "name": "sort",
                        "value": "createdDate desc"
                    },
                    {
                        "kind": "Literal",
                        "name": "viewName",
                        "value": "mc.conversationTransaction"
                    }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TransactionEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "plural": false,
                                "selections": [
                                    (v5 /*: any*/),
                                    (v11 /*: any*/),
                                    (v58 /*: any*/),
                                    (v59 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "lastShipmentQuote",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ShipmentQuote",
                                        "plural": false,
                                        "selections": [
                                            (v60 /*: any*/),
                                            (v5 /*: any*/)
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v62 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasConversationId",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "conversation",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "conversationId",
                        "variableName": "conversationId"
                    }
                ],
                "concreteType": "Conversation",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transaction",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v11 /*: any*/),
                            (v58 /*: any*/),
                            (v59 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "originalBuyer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConversationMember",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "User",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "profile",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Profile",
                                        "plural": false,
                                        "selections": [
                                            (v22 /*: any*/),
                                            (v23 /*: any*/)
                                        ]
                                    },
                                    (v7 /*: any*/),
                                    (v11 /*: any*/),
                                    (v26 /*: any*/),
                                    (v33 /*: any*/),
                                    (v34 /*: any*/),
                                    (v5 /*: any*/)
                                ]
                            },
                            (v5 /*: any*/)
                        ]
                    },
                    (v5 /*: any*/)
                ]
            }
        ]
    } as any), v63 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "canCheckZipCode",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "zipCodeLookUp",
                "name": "zipCode",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "country",
                        "variableName": "country"
                    },
                    {
                        "kind": "Variable",
                        "name": "zipCode",
                        "variableName": "zipCode"
                    }
                ],
                "concreteType": "Address",
                "plural": true,
                "selections": [
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v5 /*: any*/)
                ]
            }
        ]
    } as any), v64 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isPublic",
        "args": null,
        "storageKey": null
    } as any), v65 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "ownerId",
        "args": null,
        "storageKey": null
    } as any), v66 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalResults",
        "args": null,
        "storageKey": null
    } as any), v67 = ({
        "kind": "LinkedField",
        "alias": "totalPortfolioItems",
        "name": "items",
        "storageKey": "items(first:1)",
        "args": [
            (v13 /*: any*/)
        ],
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            (v66 /*: any*/)
        ]
    } as any), v68 = ({
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    } as any), v69 = ({
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    } as any), v70 = ({
        "kind": "Variable",
        "name": "page",
        "variableName": "page"
    } as any), v71 = ({
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
    } as any), v72 = ({
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    } as any), v73 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "numberOfPages",
        "args": null,
        "storageKey": null
    } as any), v74 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
    } as any), v75 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
    } as any), v76 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            (v74 /*: any*/),
            (v75 /*: any*/)
        ]
    } as any), v77 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v78 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contemporaryTrackingString",
        "args": null,
        "storageKey": null
    } as any), v79 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryPath",
        "args": null,
        "storageKey": null
    } as any), v80 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "retailPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v39 /*: any*/)
    } as any), v81 = [
        (v24 /*: any*/)
    ], v82 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v38 /*: any*/),
            (v24 /*: any*/)
        ]
    } as any), v83 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v84 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "versions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "webPath",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v85 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v86 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "key",
        "args": null,
        "storageKey": null
    } as any), v87 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vertical",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v11 /*: any*/),
                    (v5 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sellerProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "company",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            (v5 /*: any*/),
            (v17 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstPhotoWebPath",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "size",
                        "value": "large"
                    }
                ],
                "storageKey": "firstPhotoWebPath(size:\"large\")"
            },
            (v78 /*: any*/),
            (v79 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    (v80 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v81 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "prices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Price",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "amount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": [
                                    (v38 /*: any*/),
                                    (v82 /*: any*/)
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pricePerPiece",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hidePrice",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "negotiable",
                                "args": null,
                                "storageKey": null
                            },
                            (v83 /*: any*/),
                            (v60 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "localizedPdpUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isArt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "classification",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemClassification",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "creationDate",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creators",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemCreator",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Creator",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v5 /*: any*/)
                        ]
                    },
                    (v5 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "attribution",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "canMultipleQuantityBePurchased",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isOnHold",
                "args": null,
                "storageKey": null
            },
            (v43 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasRequestedHoldForBuyer",
                "args": (v44 /*: any*/),
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "activeHold",
                "storageKey": null,
                "args": null,
                "concreteType": "Hold",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expirationDate",
                        "args": null,
                        "storageKey": null
                    },
                    (v5 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuotes",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isLocalPickup",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isComplimentary",
                        "args": null,
                        "storageKey": null
                    },
                    (v47 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "region",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Region",
                                "plural": false,
                                "selections": [
                                    (v52 /*: any*/),
                                    (v5 /*: any*/)
                                ]
                            },
                            (v5 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            (v48 /*: any*/),
                            (v38 /*: any*/)
                        ]
                    },
                    (v5 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCustomizable",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isMultiSku",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "displayPrice",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTrade",
                        "variableName": "isTrade"
                    },
                    {
                        "kind": "Literal",
                        "name": "page",
                        "value": "searchAndBrowse"
                    }
                ],
                "concreteType": "ItemDisplayPriceType",
                "plural": true,
                "selections": [
                    (v82 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "quantityDisplay",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "percentageOff",
                        "args": null,
                        "storageKey": null
                    },
                    (v83 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPriceLabel",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPriceVariability",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "lowestShipmentQuote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "complimentaryShipping",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v54 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isWhiteGlove",
                                "args": null,
                                "storageKey": null
                            },
                            (v5 /*: any*/)
                        ]
                    },
                    (v5 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": "productPhotos",
                "name": "photos",
                "storageKey": "photos(limit:1)",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "limit",
                        "value": 1
                    }
                ],
                "concreteType": "ItemPhoto",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "placeholder",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "smallPath",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "masterOrZoomPath",
                        "args": null,
                        "storageKey": null
                    },
                    (v84 /*: any*/),
                    (v5 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "quickViewDisplay",
                "storageKey": null,
                "args": null,
                "concreteType": "QuickViewDisplayType",
                "plural": false,
                "selections": [
                    (v17 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": "mobileTitle",
                        "name": "title",
                        "args": (v85 /*: any*/),
                        "storageKey": "title(formatType:\"MOBILE\")"
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "paragraphs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewParagraph",
                        "plural": true,
                        "selections": [
                            (v86 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "text",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "mobileText",
                                "name": "text",
                                "args": (v85 /*: any*/),
                                "storageKey": "text(formatType:\"MOBILE\")"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "tilesProjects",
                        "name": "projects",
                        "storageKey": null,
                        "args": (v6 /*: any*/),
                        "concreteType": "Project",
                        "plural": true,
                        "selections": [
                            (v16 /*: any*/),
                            (v11 /*: any*/),
                            (v5 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "pdpDisplayInfo",
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": [
                            (v35 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "page",
                                "value": "pdp"
                            }
                        ],
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pricing",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PriceInfoDisplay",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showRetail",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showNet",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSale",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showPUR",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSold",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showOnHold",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v88 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "note",
        "args": null,
        "storageKey": null
    } as any), v89 = ({
        "kind": "LinkedField",
        "alias": "portfolioItems",
        "name": "items",
        "storageKey": null,
        "args": [
            (v68 /*: any*/),
            (v69 /*: any*/),
            (v70 /*: any*/),
            (v71 /*: any*/),
            (v72 /*: any*/)
        ],
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            (v66 /*: any*/),
            (v73 /*: any*/),
            (v76 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfolioItemsEdge",
                "plural": true,
                "selections": [
                    (v77 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioItemV2",
                        "plural": false,
                        "selections": [
                            (v87 /*: any*/),
                            (v5 /*: any*/),
                            (v10 /*: any*/),
                            (v88 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any), v90 = [
        (v68 /*: any*/),
        (v69 /*: any*/),
        (v71 /*: any*/),
        (v72 /*: any*/)
    ], v91 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": (v90 /*: any*/),
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            (v66 /*: any*/),
            (v73 /*: any*/),
            (v76 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfolioItemsEdge",
                "plural": true,
                "selections": [
                    (v77 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioItemV2",
                        "plural": false,
                        "selections": [
                            (v87 /*: any*/),
                            (v5 /*: any*/),
                            (v14 /*: any*/),
                            (v10 /*: any*/),
                            (v88 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any), v92 = ({
        "kind": "LinkedHandle",
        "alias": null,
        "name": "items",
        "args": (v90 /*: any*/),
        "handle": "connection",
        "key": "ItemsRefetchWrapper_items",
        "filters": [
            "searchTerm",
            "sortBy"
        ]
    } as any), v93 = ({
        "kind": "Variable",
        "name": "portfolioTypes",
        "variableName": "portfolioTypes"
    } as any), v94 = ({
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "foldersSort"
    } as any), v95 = [
        (v68 /*: any*/),
        (v69 /*: any*/),
        (v70 /*: any*/),
        (v93 /*: any*/),
        (v94 /*: any*/),
        (v9 /*: any*/)
    ], v96 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "photos",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhoto",
        "plural": true,
        "selections": [
            (v84 /*: any*/),
            (v5 /*: any*/)
        ]
    } as any), v97 = [
        (v66 /*: any*/),
        (v73 /*: any*/),
        (v76 /*: any*/),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfoliosEdge",
            "plural": true,
            "selections": [
                (v77 /*: any*/),
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": false,
                    "selections": [
                        (v14 /*: any*/),
                        (v5 /*: any*/),
                        (v11 /*: any*/),
                        (v16 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:4,sortBy:\"CUSTOM\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 4
                                },
                                {
                                    "kind": "Literal",
                                    "name": "sortBy",
                                    "value": "CUSTOM"
                                }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                                (v66 /*: any*/),
                                (v73 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "pageInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "startCursor",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v75 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemsEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioItemV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "item",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v96 /*: any*/),
                                                        (v5 /*: any*/)
                                                    ]
                                                },
                                                (v5 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ], v98 = [
        (v68 /*: any*/),
        (v69 /*: any*/),
        (v93 /*: any*/),
        (v94 /*: any*/),
        (v9 /*: any*/)
    ], v99 = ({
        "kind": "Literal",
        "name": "first",
        "value": 12
    } as any), v100 = [
        (v68 /*: any*/),
        (v99 /*: any*/),
        ({
            "kind": "Literal",
            "name": "types",
            "value": [
                "SEARCH",
                "SELLER",
                "DESIGNER",
                "USER_PREFERENCE"
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "favoritesRootQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FavoritesContainer_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "favoritesRootQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": "trendingCategories",
                            "name": "trending",
                            "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "categoryLevels",
                                    "value": 3
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "CATEGORY"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v4 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "trendingAttributes",
                            "name": "trending",
                            "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
                            "args": [
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "ATTRIBUTE"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v4 /*: any*/)
                        },
                        (v5 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isVip",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v7 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canShowSellerName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v5 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "selectedItemIds"
                                        },
                                        (v8 /*: any*/),
                                        (v9 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v10 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": (v12 /*: any*/)
                                        },
                                        (v5 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        (v13 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v12 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isDiscover",
                            "selections": [
                                (v14 /*: any*/),
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "userSurvey",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "UserSurvey",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasTakenSurvey",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "discoveryFeed",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "DiscoveryFeedTile",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ctaUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ctaText",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v15 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "header",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "imageUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "itemCreator",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "itemId",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reasonMessage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "subtitle",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "subtitleUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "tags",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "DiscoveryFeedValue",
                                                    "plural": true,
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "titleUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "tileType",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isSinglePortfolio",
                            "selections": [
                                (v18 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v42 /*: any*/),
                                (v56 /*: any*/),
                                (v57 /*: any*/),
                                (v61 /*: any*/),
                                (v62 /*: any*/),
                                (v63 /*: any*/),
                                {
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "condition": "useProjectEndpoint",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": "folderPortfolios",
                                            "name": "portfolios",
                                            "storageKey": null,
                                            "args": [
                                                (v13 /*: any*/),
                                                {
                                                    "kind": "Variable",
                                                    "name": "portfolioIds",
                                                    "variableName": "portfolioIds"
                                                }
                                            ],
                                            "concreteType": "PortfoliosConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfoliosEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PortfolioV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v15 /*: any*/),
                                                                (v64 /*: any*/),
                                                                (v65 /*: any*/),
                                                                (v67 /*: any*/),
                                                                (v89 /*: any*/),
                                                                (v91 /*: any*/),
                                                                (v92 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "useProjectEndpoint",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "project",
                                            "storageKey": null,
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "id",
                                                    "variableName": "projectId"
                                                }
                                            ],
                                            "concreteType": "Project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "portfolio",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v64 /*: any*/),
                                                        (v65 /*: any*/),
                                                        (v67 /*: any*/),
                                                        (v89 /*: any*/)
                                                    ]
                                                },
                                                (v5 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isFolders",
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "User",
                                            "plural": false,
                                            "selections": [
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "profile",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Profile",
                                                    "plural": false,
                                                    "selections": (v81 /*: any*/)
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": "foldersPortfolios",
                                            "name": "portfolios",
                                            "storageKey": null,
                                            "args": (v95 /*: any*/),
                                            "concreteType": "PortfoliosConnection",
                                            "plural": false,
                                            "selections": (v97 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": "foldersPortfolios",
                                            "name": "portfolios",
                                            "args": (v95 /*: any*/),
                                            "handle": "connection",
                                            "key": "FoldersRefetchWrapper_foldersPortfolios",
                                            "filters": [
                                                "portfolioTypes",
                                                "sortBy",
                                                "userIds",
                                                "page"
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "portfolios",
                                            "storageKey": null,
                                            "args": (v98 /*: any*/),
                                            "concreteType": "PortfoliosConnection",
                                            "plural": false,
                                            "selections": (v97 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "portfolios",
                                            "args": (v98 /*: any*/),
                                            "handle": "connection",
                                            "key": "FoldersPaginationWrapper_portfolios",
                                            "filters": [
                                                "portfolioTypes",
                                                "sortBy",
                                                "userIds"
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isFollowing",
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "User",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "favorites",
                                                    "storageKey": null,
                                                    "args": (v100 /*: any*/),
                                                    "concreteType": "favoritesConnection",
                                                    "plural": false,
                                                    "selections": [
                                                        (v66 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "edges",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "favoritesEdge",
                                                            "plural": true,
                                                            "selections": [
                                                                (v77 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "node",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Favorite",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v11 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "page",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v16 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "query",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v83 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "parameters",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Parameters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v86 /*: any*/),
                                                                                (v83 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "values",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v5 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "items",
                                                                            "storageKey": "items(first:12,page:0)",
                                                                            "args": [
                                                                                (v99 /*: any*/),
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "page",
                                                                                    "value": 0
                                                                                }
                                                                            ],
                                                                            "concreteType": "FavoriteItemsConnection",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "edges",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "FavoriteItemsEdge",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "node",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Item",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v11 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "alias": null,
                                                                                                    "name": "pdpURL",
                                                                                                    "args": null,
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v78 /*: any*/),
                                                                                                (v79 /*: any*/),
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "alias": null,
                                                                                                    "name": "seller",
                                                                                                    "storageKey": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Seller",
                                                                                                    "plural": false,
                                                                                                    "selections": (v12 /*: any*/)
                                                                                                },
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "alias": null,
                                                                                                    "name": "pricing",
                                                                                                    "storageKey": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "ItemPricing",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v80 /*: any*/)
                                                                                                    ]
                                                                                                },
                                                                                                (v96 /*: any*/),
                                                                                                (v5 /*: any*/)
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        (v5 /*: any*/),
                                                                        (v14 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "pageInfo",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                (v75 /*: any*/),
                                                                (v74 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedHandle",
                                                    "alias": null,
                                                    "name": "favorites",
                                                    "args": (v100 /*: any*/),
                                                    "handle": "connection",
                                                    "key": "FollowingRefetchWrapper_favorites",
                                                    "filters": [
                                                        "types"
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isItems",
                            "selections": [
                                (v18 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "loadPortfolioData",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": "itemsPortfolios",
                                            "name": "portfolios",
                                            "storageKey": null,
                                            "args": [
                                                (v13 /*: any*/),
                                                (v93 /*: any*/),
                                                (v9 /*: any*/)
                                            ],
                                            "concreteType": "PortfoliosConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfoliosEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PortfolioV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v64 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v67 /*: any*/),
                                                                (v89 /*: any*/),
                                                                (v91 /*: any*/),
                                                                (v92 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v42 /*: any*/),
                                (v56 /*: any*/),
                                (v57 /*: any*/),
                                (v61 /*: any*/),
                                (v62 /*: any*/),
                                (v63 /*: any*/)
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isProjects",
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "projects",
                                            "storageKey": null,
                                            "args": (v41 /*: any*/),
                                            "concreteType": "ProjectConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProjectEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Project",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "createdDate",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v16 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "installDate",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "portfolio",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PortfolioV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v11 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "items",
                                                                            "storageKey": "items(first:10)",
                                                                            "args": [
                                                                                (v55 /*: any*/)
                                                                            ],
                                                                            "concreteType": "PortfolioItemsConnection",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "edges",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PortfolioItemsEdge",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "node",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "PortfolioItemV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v5 /*: any*/)
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        (v5 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "shippingAddress",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Address",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v29 /*: any*/),
                                                                        (v30 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        (v31 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ]
                                                                },
                                                                (v5 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "User",
                                            "plural": false,
                                            "selections": [
                                                (v34 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "profile",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Profile",
                                                    "plural": false,
                                                    "selections": [
                                                        (v25 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "favoritesRootQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/favoritesRootQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '33ff81174ef461aedbb474c23023cce2';
export default node;
